import LocalizedStrings from "react-localization";

let labels = new LocalizedStrings({
  en: {},
});

export default labels;
